import React from 'react'
import { Button, FormInstance, Modal } from 'antd';
import { TFunction } from 'i18next';
import PDFViewer from 'components/Webviewer/Viewer/PDFViewer';
import { BuildNames, Languages, publicOffer } from 'interfaces/IBuildLanguage';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

const buildName: BuildNames | string = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || BuildNames.Tazadeal;

type PublicOfferModalProps = {
  isPublicOfferOpen?: boolean;
  setIsPublicOfferOpen: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  form: FormInstance<any>;
};

export default function PublicOfferModal(
  {
    isPublicOfferOpen,
    setIsPublicOfferOpen,
    t,
    form,
  }: PublicOfferModalProps
) {
  const [isAvailableAccept, setIsAvailableAccept] = React.useState<boolean>(false);
  const isAlreadyAccept = form.getFieldValue(['is_accepted_public_offer']);

  const footerWithAcceptButton = (
    <Button
      disabled={!isAvailableAccept}
      type='primary'
      onClick={() => {
        form.setFieldsValue({ is_accepted_public_offer: true });
        form.validateFields(['is_accepted_public_offer']);
        setIsPublicOfferOpen(false);
      }}
    >
      {t('Confirm.acceptButtonOffer')}
    </Button>
  );  

  return (
    <Modal
      className={cn(getTheme())}
      width={'90%'}
      onCancel={() => setIsPublicOfferOpen(false)}
      title={t('PersonalInfo.offerTitle')}
      open={isPublicOfferOpen}
      centered={true}
      footer={isAlreadyAccept ? null : footerWithAcceptButton}
    >
      <div style={{height: '80vh'}}>
        <PDFViewer
          url={publicOffer[buildName as BuildNames][Languages.Ru]} // [i18n.language as Languages] // useTranslation()
          isModal={false}
          setIsAvailableAccept={setIsAvailableAccept}
        />
      </div>
    </Modal>
  )
}

